import React from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isNil, pick } from 'lodash';
import { PayerDropdown } from './PayerDropdown';

const LanguageDropdown = ({ languages, selectedLanguage, setSelectedLanguage, disabled = false }) => {
  const { t } = useTranslation();

  const allLanguages = t('enums.languageCode.values', { returnObjects: true });

  return (
    <PayerDropdown
      items={!isNil(languages) ? pick(allLanguages, languages) : allLanguages}
      noItemsText={t('enums.languageCode.noLanguagesConfigured')}
      selectedItem={selectedLanguage}
      noSelectedItemText={t('enums.languageCode.selectLanguage')}
      onItemSelect={setSelectedLanguage}
      disabled={disabled}
    />
  );
};

LanguageDropdown.propTypes = {
  languages: PropTypes.array,
  selectedLanguage: PropTypes.string,
  setSelectedLanguage: PropTypes.func,
  disabled: PropTypes.bool,
};

export { LanguageDropdown };
